<template>
  <div>
    <div v-if="!updateCoach" class="d-flex justify-space-between">
      <div class="title">
        Coach:
        <span v-if="coach"> {{ coach.firstName }} {{ coach.lastName }} </span>
        <span v-else>
          Not set
        </span>
      </div>
      <v-icon @click="editCoach()">mdi-account-edit-outline</v-icon>
    </div>
    <div v-else class="d-flex  justify-space-between mt-2">
      <staff-picker :selected="selectedCoach" @change="selectedCoach = $event" />
      <v-btn icon small class="ml-2 mt-1" elevation="2" @click="doCoachUpdate()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn icon small class="ml-2 mt-1" elevation="2" @click="cancelEdit()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { UPDATE_SUBSCRIPTION_MUTATION } from "@/constants/graphql/users/subscription";
import StaffPicker from "@/components/shared/StaffPicker";

export default {
  components: { StaffPicker },
  props: {
    subscriptionId: {
      type: [String, Number],
      required:true
    },
    coach: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      updateCoach: false,
      staff: [],
      selectedCoach: null,
    };
  },
  methods: {
    doCoachUpdate() {
      this.$apollo
        .mutate({
          mutation: UPDATE_SUBSCRIPTION_MUTATION,
          variables: {
            input: {
              id: this.subscriptionId,
              coachUserId: this.selectedCoach,
            },
          },
        })
        .then((response) => {
          this.saving = false;
          this.$emit("coach-updated");
          if (response.data.updateSubscriptionRecord.updated) {
            this.updateCoach = false;
            this.selectedCoach = null;
            this.$toasted.success("Coach updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          } else {
            this.$toasted.error("Unable to update your Information. Sorry.", {
              icon: "alert",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    editCoach() {
      this.updateCoach = true;
      this.selectedCoach = this.coach?.id;
    },
    cancelEdit() {
      this.updateCoach = false;
      this.selectedCoach = null;
    },
  },
};
</script>
